

import Vue from 'vue'
import VueRouter from 'vue-router'
import ProjectPage from '@/components/project/ProjectPage';
import RecordingPage from '@/components/ARU/RecordingPage';
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/project', name: 'project', component: ProjectPage },
    { path: '/aru/:id', name: 'ARU', component: RecordingPage }
  ]
})

export default router;